import {
    Box,
    Button,
    Card,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    Menu,
    MenuItem,
    Paper,
    Select,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { AccessTime, Add, Delete, Edit, MoreVert, Schedule } from "@material-ui/icons"
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import {
    atualizarPeriodoDeAgendamento,
    buscarPeriodoDeAgendamento,
    cadastrarPeriodoDeAgendamento,
    deletarPeriodoDeAgendamento,
} from "../../../services/apiAgendamento"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"
import Cabecalho from "../../Cabecalho"
import { Loading } from "../../RegistradorDePedidos"

const diasSemana = [
    { id: 0, nome: "Domingo", abrev: "Dom" },
    { id: 1, nome: "Segunda-feira", abrev: "Seg" },
    { id: 2, nome: "Terça-feira", abrev: "Ter" },
    { id: 3, nome: "Quarta-feira", abrev: "Qua" },
    { id: 4, nome: "Quinta-feira", abrev: "Qui" },
    { id: 5, nome: "Sexta-feira", abrev: "Sex" },
    { id: 6, nome: "Sábado", abrev: "Sáb" },
]

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "30px",
        [theme.breakpoints.down("md")]: {
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "80px",
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "70px",
        },
        [theme.breakpoints.down("xs")]: {
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "60px",
        },
    },
    content: {
        margin: "auto",
        maxWidth: "1000px",
        [theme.breakpoints.down("sm")]: {
            maxWidth: "100%",
        },
    },
    header: {
        marginBottom: theme.spacing(4),
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(2),
            marginBottom: theme.spacing(3),
        },
    },
    headerTitle: {
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(0.5),
        },
    },
    titleText: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.5rem",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "1.25rem",
        },
    },
    addButton: {
        borderRadius: 25,
        backgroundColor: "#4caf50",
        color: "white",
        padding: theme.spacing(1, 3),
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(76, 175, 80, 0.3)",
        "&:hover": {
            backgroundColor: "#45a049",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(76, 175, 80, 0.4)",
        },
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            padding: theme.spacing(2, 3),
        },
    },
    dayCard: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            borderRadius: 15,
            marginBottom: theme.spacing(2),
        },
    },
    dayHeader: {
        backgroundColor: "#f8f9fa",
        padding: theme.spacing(2.5),
        borderBottom: "2px solid #e9ecef",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
            flexWrap: "wrap",
        },
    },
    dayHeaderTitle: {
        fontWeight: 600,
        color: "#2c3e50",
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.1rem",
        },
    },
    dayContent: {
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(2),
        },
    },
    periodCard: {
        border: "2px solid #e9ecef",
        borderRadius: 15,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        backgroundColor: "#fafafa",
        transition: "all 0.2s ease",
        "&:hover": {
            borderColor: "#4caf50",
            backgroundColor: "#f8fff8",
        },
        [theme.breakpoints.down("sm")]: {
            padding: theme.spacing(1.5),
        },
    },
    periodHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(1),
        },
    },
    periodTime: {
        display: "flex",
        alignItems: "center",
        color: "#2c3e50",
        fontWeight: 500,
        "& svg": {
            marginRight: theme.spacing(0.5),
            color: "#4caf50",
        },
    },
    periodActions: {
        display: "flex",
        gap: theme.spacing(0.5),
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            justifyContent: "flex-end",
        },
    },
    periodInfo: {
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "flex-start",
            gap: theme.spacing(1),
        },
    },
    chip: {
        borderRadius: 12,
        backgroundColor: "#e3f2fd",
        color: "#1976d2",
        fontWeight: 500,
    },
    emptyState: {
        textAlign: "center",
        padding: theme.spacing(4),
        color: "#95a5a6",
        fontStyle: "italic",
    },
    iconHeader: {
        color: "#4caf50",
        marginRight: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.2rem",
        },
    },
    formField: {
        marginBottom: theme.spacing(2),
        "& .MuiOutlinedInput-root": {
            borderRadius: 12,
            "& fieldset": {
                borderColor: "#e0e0e0",
            },
            "&:hover fieldset": {
                borderColor: "#4caf50",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#4caf50",
            },
        },
    },
    dialogActions: {
        padding: theme.spacing(2),
        gap: theme.spacing(1),
    },
    saveButton: {
        borderRadius: 15,
        backgroundColor: "#4caf50",
        color: "white",
        "&:hover": {
            backgroundColor: "#45a049",
        },
    },
    cancelButton: {
        borderRadius: 15,
        color: "#666",
    },
}))

function hhmmToMinutes(hhmm) {
    const [hh, mm] = hhmm.split(":").map(Number)

    if (!Number.isInteger(hh) || !Number.isInteger(mm) || hh < 0 || mm < 0 || mm > 59) {
        throw new Error("Formato inválido. Use 'HH:MM' (ex: '12:00').")
    }

    return hh * 60 + mm
}
function minutesToHHMM(totalMinutes) {
    if (!Number.isFinite(totalMinutes) || !Number.isInteger(totalMinutes)) {
        throw new Error("Minutos inválidos. Use um número inteiro (ex: 90).")
    }
    if (totalMinutes < 0) {
        throw new Error("Minutos inválidos. Não pode ser negativo.")
    }

    const hh = Math.floor(totalMinutes / 60)
    const mm = totalMinutes % 60

    const hhStr = String(hh).padStart(2, "0")
    const mmStr = String(mm).padStart(2, "0")

    return `${hhStr}:${mmStr}`
}

export function PeriodoAgendamento() {
    const classes = useStyles()
    const setLoading = useLoadingStore(s => s.setLoading)
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }
    const autorizacao = localStorage.getItem("chaveSistema")
    const configuracoesEst = useAppStore(s => s.configuracoes)
    const idEstabelecimento = configuracoesEst.user.parametros.estabelecimento.id

    const [periodos, setPeriodos] = useState([])
    const [openDialog, setOpenDialog] = useState(false)
    const [editingPeriod, setEditingPeriod] = useState(null)
    const [anchorEl, setAnchorEl] = useState(null)
    const [selectedPeriod, setSelectedPeriod] = useState(null)

    const [formData, setFormData] = useState({
        diaSemana: 1,
        horaInicio: "",
        horaFim: "",
        capacidadePorSlotSub: "",
    })

    const handleOpenDialog = (period = null) => {
        if (period) {
            setEditingPeriod(period)
            setFormData({
                id: period.id,
                diaSemana: period.diaSemana,
                horaInicio: minutesToHHMM(period.horaInicio),
                horaFim: minutesToHHMM(period.horaFim),
                capacidadePorSlotSub: period.capacidadePorSlotSub ?? "",
            })
        } else {
            setEditingPeriod(null)
            setFormData({
                id: null,
                diaSemana: 1,
                horaInicio: "",
                horaFim: "",
                capacidadePorSlotSub: "",
            })
        }
        setOpenDialog(true)
    }

    const handleCloseDialog = () => {
        setOpenDialog(false)
        setEditingPeriod(null)
    }

    const handleMenuOpen = (event, period) => {
        setAnchorEl(event.currentTarget)
        setSelectedPeriod(period)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
        setSelectedPeriod(null)
    }

    const handleSalvarPeriodo = async () => {
        setLoading(true)

        try {
            if (!formData.horaInicio || !formData.horaFim) {
                alertStart("Preencha os horários de início e fim", "error")
                return
            }

            if (formData.horaInicio >= formData.horaFim) {
                alertStart("Horário de início deve ser menor que o horário de fim", "error")
                return
            }

            const data = {
                dia: formData.diaSemana,
                horaInicio: hhmmToMinutes(formData.horaInicio),
                horaFim: hhmmToMinutes(formData.horaFim),
                capacidadePorSlotSub: Number(formData.capacidadePorSlotSub) || null,
            }

            const response = await cadastrarPeriodoDeAgendamento(
                data,
                idEstabelecimento,
                autorizacao
            )
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                setPeriodos(prev => [...prev, response])
                alertStart("Período salvo com sucesso", "success")
                handleCloseDialog()
            }
        } catch (error) {
            console.log("erro", error)
        } finally {
            setLoading(false)
        }
    }

    const handleDeletarPeriodo = async idPeriodo => {
        try {
            setLoading(true)

            const response = await deletarPeriodoDeAgendamento(
                idPeriodo,
                idEstabelecimento,
                autorizacao
            )
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                setPeriodos(prev => prev.filter(p => p.id !== idPeriodo))
                alertStart("Período removido com sucesso!", "success")
                handleMenuClose()
            }
        } catch (error) {
            console.log("erro", error)
        } finally {
            setLoading(false)
        }
    }

    const handleBuscarPeriodoDeAgendamento = async () => {
        setLoading(true)
        try {
            const response = await buscarPeriodoDeAgendamento(idEstabelecimento, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                setPeriodos(response)
            }
        } catch (error) {
            console.log("erro", error)
        } finally {
            setLoading(false)
        }
    }

    const handleAtualizarPeriodosDeAgendamento = async idPeriodo => {
        const data = {
            id: Number(idPeriodo),
            dia: formData.diaSemana,
            horaInicio: hhmmToMinutes(formData.horaInicio),
            horaFim: hhmmToMinutes(formData.horaFim),
            capacidadePorSlotSub: Number(formData.capacidadePorSlotSub) || null,
        }

        try {
            setLoading(true)
            const response = await atualizarPeriodoDeAgendamento(
                data,
                idEstabelecimento,
                autorizacao
            )
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
            } else {
                setPeriodos(prev =>
                    prev.map(p =>
                        Number(p.id) === Number(data.id) ? { ...data, diaSemana: data.dia } : p
                    )
                )
                alertStart("Período atualizado com sucesso", "success")
                handleCloseDialog()
                handleMenuClose()
            }
        } catch (error) {
            console.log("erro", error)
        } finally {
            setLoading(false)
        }
    }

    const periodosPorDia = diasSemana
        .map(dia => ({
            ...dia,
            periodos: periodos.length > 0 ? periodos?.filter(p => p.diaSemana === dia.id) : [],
        }))
        ?.filter(dia => dia.periodos.length > 0)

    const handleChange = field => e => {
        const value = e.target.value
        setFormData(prev => ({ ...prev, [field]: value }))
    }

    useEffect(() => {
        handleBuscarPeriodoDeAgendamento()
    }, [])

    return (
        <>
            <Loading />
            <Cabecalho pagina={"Períodos de Agendamento"} />
            <div className={classes.container}>
                <div className={classes.content}>
                    <Box className={classes.header}>
                        <Box className={classes.headerTitle}>
                            <Box display="flex" alignItems="center">
                                <Typography variant="h4" className={classes.titleText}>
                                    Períodos de Agendamento
                                </Typography>
                            </Box>
                            <Typography variant="subtitle1" style={{ color: "#7f8c8d" }}>
                                Configure os horários disponíveis para agendamento por dia da semana
                            </Typography>
                        </Box>
                        <Button
                            className={classes.addButton}
                            startIcon={!isMobile && <Add />}
                            onClick={() => handleOpenDialog()}
                        >
                            {isMobile ? "➕ Adicionar Período" : "Adicionar Período"}
                        </Button>
                    </Box>

                    {periodosPorDia.length > 0 ? (
                        periodosPorDia.map(dia => (
                            <Paper key={dia.id} className={classes.dayCard}>
                                <Box className={classes.dayHeader}>
                                    <Typography variant="h6" className={classes.dayHeaderTitle}>
                                        {dia.nome}
                                    </Typography>
                                    <Chip
                                        label={`${dia.periodos.length} período${
                                            dia.periodos.length !== 1 ? "s" : ""
                                        }`}
                                        className={classes.chip}
                                        size="small"
                                    />
                                </Box>
                                <Box className={classes.dayContent}>
                                    {dia.periodos.map(periodo => (
                                        <Card key={periodo.id} className={classes.periodCard}>
                                            <Box className={classes.periodHeader}>
                                                <Typography className={classes.periodTime}>
                                                    <AccessTime />
                                                    {minutesToHHMM(periodo.horaInicio)} -{" "}
                                                    {minutesToHHMM(periodo.horaFim)}
                                                </Typography>
                                                <Box className={classes.periodActions}>
                                                    <IconButton
                                                        size="small"
                                                        onClick={e => handleMenuOpen(e, periodo)}
                                                    >
                                                        <MoreVert />
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                            <Box className={classes.periodInfo}>
                                                <Chip
                                                    label={
                                                        periodo.capacidadePorSlotSub
                                                            ? `${periodo.capacidadePorSlotSub} pedidos/intervalo`
                                                            : "Configuração padrão"
                                                    }
                                                    size="small"
                                                    style={{
                                                        backgroundColor:
                                                            periodo.capacidadePorSlotSub
                                                                ? "#fff3e0"
                                                                : "#e8f5e8",
                                                        color: periodo.capacidadePorSlotSub
                                                            ? "#f57c00"
                                                            : "#4caf50",
                                                    }}
                                                />
                                            </Box>
                                        </Card>
                                    ))}
                                </Box>
                            </Paper>
                        ))
                    ) : (
                        <Paper className={classes.dayCard}>
                            <Box className={classes.dayContent}>
                                <Box className={classes.emptyState}>
                                    <Schedule
                                        style={{ fontSize: 48, color: "#bdc3c7", marginBottom: 16 }}
                                    />
                                    <Typography
                                        variant="h6"
                                        style={{ color: "#7f8c8d", marginBottom: 8 }}
                                    >
                                        Nenhum período configurado
                                    </Typography>
                                    <Typography variant="body2" style={{ color: "#95a5a6" }}>
                                        Clique em "Adicionar Período" para começar a configurar os
                                        horários de agendamento
                                    </Typography>
                                </Box>
                            </Box>
                        </Paper>
                    )}

                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        keepMounted
                    >
                        <MenuItem onClick={() => handleOpenDialog(selectedPeriod)}>
                            <Edit style={{ marginRight: 8 }} />
                            Editar
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                handleDeletarPeriodo(selectedPeriod?.id)
                            }}
                            style={{ color: "#f44336" }}
                        >
                            <Delete style={{ marginRight: 8 }} />
                            Excluir
                        </MenuItem>
                    </Menu>

                    <Dialog
                        open={openDialog}
                        onClose={handleCloseDialog}
                        maxWidth="sm"
                        fullWidth
                        PaperProps={{ style: { borderRadius: 20 } }}
                    >
                        <DialogTitle>
                            <Box display="flex" alignItems="center">
                                <Schedule style={{ marginRight: 8, color: "#4caf50" }} />
                                {editingPeriod ? "Editar Período" : "Adicionar Período"}
                            </Box>
                        </DialogTitle>
                        <DialogContent style={{ padding: 24 }}>
                            <FormControl fullWidth className={classes.formField}>
                                <InputLabel>Dia da Semana</InputLabel>
                                <Select
                                    label="Dia da Semana"
                                    value={formData.diaSemana}
                                    onChange={e =>
                                        setFormData(prev => ({
                                            ...prev,
                                            diaSemana: e.target.value,
                                        }))
                                    }
                                    variant="outlined"
                                >
                                    {diasSemana.map(dia => (
                                        <MenuItem key={dia.id} value={dia.id}>
                                            {dia.nome}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        label="Horário de Início"
                                        type="time"
                                        value={formData.horaInicio}
                                        onChange={handleChange("horaInicio")}
                                        abelProps={{ shrink: true }}
                                        variant="outlined"
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        label="Horário de Fim"
                                        type="time"
                                        value={formData.horaFim}
                                        onChange={handleChange("horaFim")}
                                        InputLabelProps={{ shrink: true }}
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>

                            <TextField
                                style={{ marginTop: "1.1rem" }}
                                fullWidth
                                label="Pedidos por Intervalo (opcional)"
                                type="number"
                                value={formData.capacidadePorSlotSub}
                                onChange={handleChange("capacidadePorSlotSub")}
                                className={classes.formField}
                                variant="outlined"
                                helperText="Deixe vazio para usar a configuração padrão"
                                inputProps={{ min: 1 }}
                            />
                        </DialogContent>
                        <DialogActions className={classes.dialogActions}>
                            <Button onClick={handleCloseDialog} className={classes.cancelButton}>
                                Cancelar
                            </Button>
                            <Button
                                onClick={() => {
                                    editingPeriod
                                        ? handleAtualizarPeriodosDeAgendamento(editingPeriod.id)
                                        : handleSalvarPeriodo()
                                }}
                                className={classes.saveButton}
                            >
                                {editingPeriod ? "Atualizar" : "Adicionar"}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
        </>
    )
}
